import { Controller } from "@hotwired/stimulus"

// Before/after image comparison: the "after" image is clipped to the handle's
// position, so dragging (or arrowing) across wipes between the two.
//
//   <div data-controller="before-after">
//     <img data-before-after-target="before">
//     <div data-before-after-target="after"><img></div>
//     <input type="range" data-before-after-target="range"
//            data-action="input->before-after#slide">
//   </div>
export default class extends Controller {
  static targets = ["after", "range", "handle", "hint"]

  connect() {
    this.apply(this.hasRangeTarget ? Number(this.rangeTarget.value) : 50)
  }

  slide(event) {
    this.touched()
    this.apply(Number(event.currentTarget.value))
  }

  // The hint has done its job once the customer has dragged once.
  touched() {
    if (this.hasHintTarget) this.hintTarget.classList.add("is-gone")
  }

  // Click anywhere on the frame to jump the wipe there.
  jump(event) {
    const rect = this.element.getBoundingClientRect()
    if (rect.width === 0) return
    const pct = ((event.clientX - rect.left) / rect.width) * 100
    const clamped = Math.min(100, Math.max(0, pct))
    this.touched()
    if (this.hasRangeTarget) this.rangeTarget.value = clamped
    this.apply(clamped)
  }

  apply(percent) {
    if (this.hasAfterTarget) {
      // inset(top right bottom left): the after image shows to the RIGHT of
      // the handle, under the DESPUÉS tag. It used to be revealed from the
      // left, under the ANTES tag, and a customer read our render as the
      // picture they had sent.
      this.afterTarget.style.clipPath = `inset(0 0 0 ${percent}%)`
    }
    if (this.hasHandleTarget) {
      this.handleTarget.style.left = `${percent}%`
    }
  }
}
